import React from 'react';
import {List} from 'immutable';
import DashboardSidebar from 'components/pure/admin/DashboardSidebar';

const sidebarMenu = List([
  {
    name: 'Profile',
    url: '/admin/profile',
  },
  {
    name: 'Smart Alerts',
    url: '/admin/actions',
  },
]);

export default class UserSettingsSidebar extends React.Component {
  render() {
    return <DashboardSidebar sidebarMenu={sidebarMenu} sidebarOpen={this.props.sidebarOpen} />;
  }
}
